import { useMutation } from '@tanstack/react-query';
import { Spin } from 'antd';
import { assetApi } from '../../../../../apis';
import ButtonAgreeWhite from '../../../../../components/buttonCustom/ButtonAgreeWhite';
import NotificationError from '../../../../../components/notification/NotificationError';
import { regexImage } from '../../../../../validate/validator.validate';
import { TrashImgSvg } from '../../../itemMangement/itemDetail/@svg/trashImg';
import './index.scss';
import { PenEditImgSvg } from '../../../itemMangement/itemDetail/@svg/editImg';
import { MouseEvent, useEffect, useRef, useState } from 'react';
import { Asset } from '../../../../../apis/client-axios';
import { FileConfig } from '../../../../../constants/config';

type TImageItemReturn = {
  type: 'ADD' | 'PREVIEW';
  url: string;
  index: number;
  onUploadSuccess?: (data: Asset, index: number) => void;
  onRemove?: (index: number) => void;
  width?: number;
  disabled?: boolean;
};
const ImageItemReturn = ({
  type,
  url,
  index,
  width = 64,
  onRemove,
  onUploadSuccess,
  disabled = false,
}: TImageItemReturn) => {
  const inputRef = useRef<HTMLInputElement>();
  const [imageStatus, setImageStatus] = useState<'idle' | 'loading' | 'loaded' | 'error'>(url ? 'loading' : 'idle');

  useEffect(() => {
    if (!url) {
      setImageStatus('idle');
      return;
    }

    setImageStatus('loading');
    const preloadImage = new window.Image();

    preloadImage.onload = () => {
      setImageStatus('loaded');
    };

    preloadImage.onerror = () => {
      setImageStatus('error');
    };

    preloadImage.src = url;
  }, [url]);

  const { mutate: UpdateFile, isPending } = useMutation({
    mutationFn: (file: File) => assetApi.assetControllerUploadFile(file, 'storage-request'),
    onSuccess: ({ data }) => {
      const img = data as Asset;
      if (inputRef?.current?.value) inputRef.current.value = '';
      !!onUploadSuccess && onUploadSuccess(img, index);
    },
  });

  const onChange = (file: File) => {
    if (!file || !regexImage.test(file.type)) {
      return NotificationError({ content: '画像アップロードできませんでした。' });
    }
    return UpdateFile(file);
  };

  const onChangeImg = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    inputRef?.current?.click();
  };

  const cursorStyle = {
    cursor: disabled ? 'default' : 'pointer',
  };

  return (
    <div className="image-return" id="image-return" style={cursorStyle}>
      {url && imageStatus === 'error' ? (
        <div className="image-return__error" onClick={type === 'ADD' ? onChangeImg : undefined} />
      ) : url && imageStatus === 'loaded' ? (
        <img
          className="image-return__img"
          src={url}
          alt=""
          width={width}
          onClick={type === 'ADD' ? onChangeImg : undefined}
        />
      ) : url && imageStatus === 'loading' ? (
        <div className="image-return__error" onClick={type === 'ADD' ? onChangeImg : undefined} />
      ) : (
        <img
          className="image-return__img"
          src="assets/icons/avatar/default-item.png"
          alt=""
          width={width}
          onClick={type === 'ADD' ? onChangeImg : undefined}
        />
      )}
      {type === 'ADD' && url && (
        <div className="btn-action">
          <ButtonAgreeWhite
            subClass="btn-edit"
            value={<img src="/assets/icons/icon_edit_1x.png" alt="icon-edit" />}
            onClick={onChangeImg}
          />
          <ButtonAgreeWhite
            subClass="btn-delete"
            value={<img src="/assets/icons/icon_delete_1x.png" alt="icon-delete" />}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              !!onRemove && onRemove(index);
            }}
          />
        </div>
      )}
      <input
        multiple={false}
        ref={inputRef}
        className="hidden"
        type="file"
        accept={FileConfig.imageAccept}
        onChange={(e) => onChange(e.target.files[0])}
      />
      {isPending && (
        <div className="loading">
          <Spin />
        </div>
      )}
    </div>
  );
};

export default ImageItemReturn;
